class NewHeader extends HTMLElement {
  constructor() {
    super()

    // selectors
    this.selectors = {
      'MENU_TOGGLE': '.menu-toggle',
      'PRIMARY_MENU': '.primary-menu',
      'NAV_DROPDOWN': '.nav_dropdown',
      'DRAWER_TOGGLE': '.drawer_toggle',
    }

    // elements
    this.menuToggles = document.querySelectorAll(this.selectors['MENU_TOGGLE'])
    this.primaryMenu = document.querySelector(this.selectors['PRIMARY_MENU'])
    this.dropdownLinks = document.querySelectorAll(`${this.selectors['NAV_DROPDOWN']} a`)
    this.drawerToggles = document.querySelectorAll(this.selectors['DRAWER_TOGGLE'])
  }

  connectedCallback() {
    /********************************************************
     * menu toggle handler that open/hide mobile menu
     ********************************************************/
    this.menuToggles.forEach(toggle => {
      toggle.addEventListener('click', e => {
        e.stopPropagation() // prevent click from reaching body
        document.body.classList.toggle('menu-active')
        document.body.classList.toggle('overflow-hidden')
      })
    })

    /********************************************************
     * mobile menu dropdown links handler
     ********************************************************/
    this.dropdownLinks.forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault() // prevent link navigation (optional)

        const currentDropdown = e.currentTarget.closest(this.selectors['NAV_DROPDOWN'])

        // Remove 'active' from all dropdowns except the current one
        document.querySelectorAll('.dropdown').forEach(dropdown => {
          if (dropdown !== currentDropdown) {
            dropdown.classList.remove('active')
          }
        })

        // Toggle 'active' on the clicked dropdown
        currentDropdown.classList.toggle('active')
      })
    })

    /********************************************************
     * slider cart open/hide module
     ********************************************************/
    this.drawerToggles.forEach(toggle => {
      toggle.addEventListener('click', e => {
        e.preventDefault()
        document.querySelector('.shopping_cart').classList.toggle('modal_show')
      })
    })

    /********************************************************
     * auto close menu drawer
     ********************************************************/
    document.addEventListener('click', e => {
      if (!this.primaryMenu.contains(e.target) && !e.target.closest(this.selectors['MENU_TOGGLE'])) {
        document.body.classList.remove('menu_active', 'overflow-hidden')
      }
    })
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.clickHandler)
  }
}

customElements.define('new-header', NewHeader)

/********************************************************
 * sticky header module
 ********************************************************/
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header')
  const mainContent = document.getElementById('MainContent')
  if (window.location.href.includes('/collections/')) {
    mainContent.style.top = '180px'
    mainContent.style.position = 'relative'
  }
  const stickyHeader = () => {
    if (window.scrollY > 20) {
      header.classList.add('header_sticky')
      if (window.location.href.includes('/collections/')) {
        mainContent.style.top = '156px'
      }
    } else {
      header.classList.remove('header_sticky')
      if (window.location.href.includes('/collections/')) {
        mainContent.style.top = '180px'
      }
    }
  }

  // Run once on load
  stickyHeader()

  // Update on scroll
  window.addEventListener('scroll', stickyHeader)
})

/********************************************************
 * search boxes
 ********************************************************/
document.addEventListener('DOMContentLoaded', () => {
  const searchBoxes = document.querySelectorAll('.search_box')

  searchBoxes.forEach(searchBox => {
    const searchBtn = searchBox.querySelector('.search_btn')
    const searchToggle = searchBox.querySelector('.search_toggle')
    const searchHide = searchBox.querySelector('.search_hide')
    const searchField = searchBox.querySelector('.search_field')

    // Toggle search field on button click
    searchBtn.addEventListener('click', function (e) {
      e.stopPropagation()

      const isActive = searchField.classList.toggle('active')

      if (isActive) {
        searchToggle.classList.add('hidden')
        searchHide.classList.remove('hidden')
        searchField.classList.remove('pointer-events-none')
      } else {
        hideSearch()
      }
    })

    // Close search when clicking outside
    document.addEventListener('click', function (e) {
      if (!searchBox.contains(e.target)) {
        hideSearch()
      }
    })

    // Function to hide search
    const hideSearch = () => {
      searchField.classList.remove('active')
      searchField.classList.add('pointer-events-none')
      searchToggle.classList.remove('hidden')
      searchHide.classList.add('hidden')
    }
  })
})

/**********************************************
 * @name announcement-slider
 * @description swiper based announcement slider
 **********************************************/
let announcementSlider = null

const initAnnouncementSlider = () => {
  const container = document.querySelector('.announcement-slider')
  if (!container) return

  // Destroy existing instance safely
  if (announcementSlider && announcementSlider.destroy) {
    try { announcementSlider.destroy(true, true) } catch (e) { console.error('Error:', error) }
    announcementSlider = null
  }

  announcementSlider = new Swiper(container, {
    slidesPerView: 1,
    loop: false,
    observer: true,
    autoplay: {
      delay: 2000,
    },
    observeParents: true,
    observeSlideChildren: true,
    on: {
      init() {
        this.update();
        setTimeout(() => this.update(), 50)
      }
    }
  })
}

document.addEventListener('DOMContentLoaded', initAnnouncementSlider)
window.addEventListener('load', () => announcementSlider?.update())
window.addEventListener('resize', () => {
  clearTimeout(announcementSlider?.resizeTimer)
  announcementSlider.resizeTimer = setTimeout(() => announcementSlider?.update(), 150)
})
